import "./App.css";
import { Route, Routes } from "react-router-dom";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import MainSection from "./pages/MainSection";
import { useEffect } from "react";
import Aos from "aos";
import Contact from "./pages/Contact";
import Portfolio from "./pages/Portfolio";
import ProjectDetails from "./pages/ProjectDetails";
import Learn from "./pages/Learn";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import UnderConstruction from "./pages/UnderConstruction";
import AdminLogin from "./pages/AdminLogin";
import RequireAuth from "./pages/RequireAuth";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<MainSection />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/projects/:id" element={<ProjectDetails />} />
        <Route path="/learn" element={<Learn />} />
        <Route
          path="/admin/dashboard"
          element={
            <RequireAuth>
              <AdminDashboard />
            </RequireAuth>
          }
        />
        <Route path="/underConstruction" element={<UnderConstruction />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
